import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";

import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";
import { store } from "../store";

const uuidv4 = require("uuid/v4");

export function* registerDevice() {
  yield takeEvery(actionTypes.REGISTER_DEVICE, function* (action) {
    yield put(actions.enableLoading());
    // console.log(action.data ? action.data : "none");
    try {
      let params = {
        uuid: action.data ? action.data : uuidv4(),
        app_token: "LOLOL-CONSUMER-WEB",
        language: "en",
      };
      const response = yield API.registerDevice(params);
      if (response.data.success && response.data.data) {
        yield API.SetAxiosAuthBearer(response.data.token);
        yield put(
          actions.registerDeviceSuccess(
            response.data.token,
            response.data.data.uuid
          )
        );
      } else {
        alert("Warning: Fail to register device. " + response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert("Error: Fail to register device. " + API.constructErrMsg(error));
      yield put(actions.disableLoading());
    }
  });
}

export function* login() {
  yield takeEvery(actionTypes.CONSUMER_LOGIN, function* (action) {
    yield put(actions.enableLoading());

    // Login
    try {
      const response = yield API.login(action.data);

      if (response.data.success && response.data.token && response.data.data) {
        yield API.SetAxiosAuthBearer(response.data.token);
        yield put(
          actions.consumerLoginSuccess(
            response.data.token,
            response.data.data,
            action.data
          )
        );

        const lastPath = store.getState().Auth.lastPath;
        if (lastPath !== null) {
          yield put(push(lastPath));
          yield put(actions.consumerRedirectLastPath());
        }
      } else {
        alert("Warning: Fail to login. " + response.data.message);
        yield put(actions.consumerLoginFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to login."));
      yield put(actions.consumerLoginFail());
      yield put(actions.disableLoading());
    }
    // Register Device
    // try {
    //   let params = { uuid: uuidv4(), app_token: "LOLOL-CONSUMER-WEB" };
    //   const responseDevice = yield API.registerDevice(params);
    //   if (responseDevice.data.success && responseDevice.data.token) {
    //     yield API.SetAxiosAuthBearer(responseDevice.data.token);

    //   } else {
    //     alert(
    //       "Warning: Fail to register device. " + responseDevice.data.message
    //     );
    //     yield put(actions.disableLoading());
    //   }
    // } catch (error) {
    //   yield put(actions.handleAPIError(error, "Fail to register device."));
    //   yield put(actions.registerDeviceFail());
    //   yield put(actions.disableLoading());
    // }
  });
}

export function* logout() {
  yield takeEvery(actionTypes.CONSUMER_LOGOUT, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.logout();
      if (response.data.success) {
        yield put(actions.consumerLogoutSuccess());
        yield put(actions.registerDevice());
      } else {
        alert("Warning: Fail to logout. " + response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      if (error.response.status === 401) {
        yield put(actions.consumerLogoutSuccess());
      } else {
        yield put(actions.handleAPIError(error, "Fail to login."));
      }

      yield put(actions.disableLoading());
    }
  });
}

export function* relogin() {
  yield takeEvery(actionTypes.CONSUMER_RELOGIN, function* (action) {
    try {
      const response = yield API.relogin(action.data);
      if (response.data.success && response.data.data) {
        yield API.SetAxiosAuthBearer(response.data.token);
        yield put(actions.consumerReloginSuccess(response.data.token));
        yield put(actions.getConsumerDetail());
      } else {
        // console.log("Warning: Fail to refresh token. " + response.data.message);
        yield put(actions.consumerReloginFail());
        yield put(
          actions.consumerForceLogout(
            "Warning: Fail to refresh token. " + response.data.message
          )
        );
      }
    } catch (error) {
      //   console.log(
      //     "Warning: Fail to refresh token. " + API.constructErrMsg(error)
      //   );
      yield put(actions.consumerReloginFail());
      yield put(
        actions.consumerForceLogout(
          "Warning: Fail to refresh token. " + API.constructErrMsg(error)
        )
      );
      yield put(actions.consumerLogoutSuccess());
    }
  });
}

export function* forceLogout() {
  yield takeEvery(actionTypes.CONSUMER_FORCE_LOGOUT, function* (action) {
    yield put(actions.enableLoading());
    yield put(actions.consumerForceLogoutSuccess());
    yield put(actions.registerDevice());
    yield put(actions.disableLoading());
  });
}

export function* sendSMS() {
  yield takeEvery(actionTypes.SEND_SMS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.sendSMS(action.data);
      if (response.data.success) {
        yield put(actions.sendSMSSuccess());
      } else {
        alert("Warning: Fail to send SMS. " + response.data.message);
        yield put(actions.sendSMSFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert("Error: Fail to send SMS. " + API.constructErrMsg(error));
      yield put(actions.sendSMSFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* verifySMS() {
  yield takeEvery(actionTypes.VERIFY_SMS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.verifySMS(action.data);
      if (response.data.success) {
        yield put(actions.verifySMSSuccess());
      } else {
        // console.log(
        //   "Warning: Fail to verify verification code. " + response.data.message
        // );
        yield put(actions.verifySMSFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      //   console.log(
      //     "Error: Fail to verify verification code. " + API.constructErrMsg(error)
      //   );
      yield put(actions.verifySMSFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* resetPassword() {
  yield takeEvery(actionTypes.RESET_PASSWORD, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.resetPassword(action.data);
      if (response.data.success) {
        yield put(actions.resetPasswordSuccess());
      } else {
        alert("Warning: Fail to reset password. " + response.data.message);
        yield put(actions.resetPasswordFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert("Error: Fail to reset password. " + API.constructErrMsg(error));
      yield put(actions.resetPasswordFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* signUp() {
  yield takeEvery(actionTypes.CONSUMER_SIGN_UP, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.signUp(action.data);
      if (response.data.success) {
        if (response.data.invalidReferralID) {
          alert("Warning: Fail to register. " + response.data.message);
          yield put(actions.consumerSignUpFail());
          yield put(actions.storeLOLOLID(""));
        } else {
          yield put(actions.consumerSignUpSuccess());
          yield put(actions.toastSuccess(response.data.message));

          // Login
          let params = {
            country_code: action.data.country_code,
            phone_no: action.data.phone_no,
            password: action.data.password,
          };

          yield put(actions.consumerLogin(params));
        }
      } else {
        alert("Warning: Fail to register. " + response.data.message);
        yield put(actions.consumerSignUpFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      let error_msg = API.constructErrMsg(error);
      alert("Error: Fail to register. " + error_msg);
      yield put(actions.consumerSignUpFail());
      if (error_msg && error_msg.toLowerCase().includes("invalid referral")) {
        yield put(actions.storeLOLOLID(""));
      }
      yield put(actions.disableLoading());
    }
  });
}

export function* getConsumerProfileDetails() {
  yield takeEvery(actionTypes.GET_CONSUMER_PROFILE_DETAILS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getConsumerProfileDetails();
      if (response.data.success && response.data.data) {
        yield put(actions.getConsumerProfileDetailsSuccess(response.data.data));

        // Check for food preference User firstLoad
        let data = response.data.data;
        let productPref = JSON.parse(
          window.localStorage.getItem("persist:ProductPref")
        );
        let product_preference = JSON.parse(
          productPref && productPref.productPreference
            ? productPref.productPreference
            : {}
        );
        if (data.food_perf === null) {
          if (
            JSON.stringify(product_preference.data.food_perf) !==
            JSON.stringify({})
          ) {
            yield put(
              actions.setProductPreference(
                { food_perf: product_preference.data.food_perf },
                false
              )
            );
          }
        }
      } else {
        alert("Warning: Fail to get profile details. " + response.data.message);
        yield put(actions.getConsumerProfileDetailsFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert(
        "Error: Fail to get profile details. " + API.constructErrMsg(error)
      );
      yield put(actions.getConsumerProfileDetailsFail());
      yield put(actions.disableLoading());
    }
  });
}

export default function* authSaga() {
  yield all([
    fork(registerDevice),
    fork(login),
    fork(logout),
    fork(forceLogout),
    fork(relogin),
    fork(sendSMS),
    fork(verifySMS),
    fork(resetPassword),
    fork(signUp),
    fork(getConsumerProfileDetails),
  ]);
}
